import type { Resource } from '../../';
export const search_box_frame_removeFromHistory: Resource = {"default":"Remove {term} from Search History"};
